import { MarkPumpPagination } from '../../../pumpMark/domain/model/markPump_pagination';
import { FetchPumpTrackingByIDRepository } from '../../data/repository/fetch_pump_tracking_by_id_repository';
import { Pagination } from "@/core/domain/model/pagination";
import { DataOptions } from "vuetify";
import { en } from '@/module/pumpMark/domain/model/markPump';

export interface FetchPumpTrackingByIDUseCase {
    (id: number, pagination: DataOptions, search: string): Promise<MarkPumpPagination>
}

const fetchPumpTrackingByIDUseCase = (repository: FetchPumpTrackingByIDRepository): FetchPumpTrackingByIDUseCase => async (id: number, pagination: DataOptions, search: string) => {
    try {
        const payload: Pagination = {
            sort: pagination.sortBy.map((s: string) => en[s]).join(','),
            descending: pagination.sortDesc.join(','),
            page: pagination.page,
            itemsPerPage: pagination.itemsPerPage,
            search: search
        }
        
        return await repository(id, payload);
    } catch (error) {
        throw error
    }
}

export default fetchPumpTrackingByIDUseCase;